// components/Layout/Topbar/UserAvatar.jsx
import React from "react";

const UserAvatar = ({ user, showStatus = false, size = "md" }) => {
  const sizeClasses = {
    sm: "w-8 h-8",
    md: "w-10 h-10",
    lg: "w-12 h-12"
  };

  const statusClasses = {
    sm: "w-2 h-2",
    md: "w-3 h-3", 
    lg: "w-4 h-4"
  };

  const defaultImage = "https://grofresh-admin.6amtech.com/storage/app/public/admin/2023-10-21-65335c1bd07bd.png";

  return (
    <div className="relative">
      <img
        className={`${sizeClasses[size]} rounded-full object-cover border-2 border-gray-200`}
        src={
          user?.profile_picture
            ? `https://rxultimate.com/${user?.profile_picture}`
            : defaultImage
        }
        alt={`${user?.first_name} ${user?.last_name}`}
      />
      {showStatus && (
        <span className={`absolute bottom-0 right-0 ${statusClasses[size]} bg-green-500 rounded-full border-2 border-white`} />
      )}
    </div>
  );
};

export default UserAvatar;